// eslint-disable-next-line import/no-extraneous-dependencies
import crypto from "crypto-js";

export function generateSEKAndHash(token: any) {
  const iv = "D904363DB8DACEB8";
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = {};
    console.log("TOKEEEEEEN",token);
    if (token === "" || token === null || token === undefined) {
      dataPayload = {
        // authorization: `Bearer `,
        appkey: new Date().toISOString(),
      };
    } else {
      dataPayload = {
        authorization: `Bearer ${token}`,
        appkey:  new Date().toISOString(),
      };
    }
    let appkey = JSON.stringify(dataPayload);
    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}

export function generateEncryptedKeyBody(body: any) {
  const iv = "D904363DB8DACEB8";
  try {
    const key = crypto.lib.WordArray.random(32);
    let dataPayload = JSON.stringify(body);

    const encrypted = crypto.AES.encrypt(dataPayload, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });
    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
